import { ACCENT, INK, PAPER, illustrationA11y, lineStyle } from './static-art';

export function PhoneConfirmationIllustration(props: {
	className?: string;
	label?: string;
	ink?: string;
	paper?: string;
}) {
	const ink = props.ink ?? INK;
	const line = lineStyle(ink, 1.2);
	return (
		<svg
			width="196"
			height="146"
			viewBox="0 0 196 146"
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M86.6494 16.9487L39.9643 28.3226C35.7221 29.3561 33.1213 33.6342 34.1552 37.8778L57.9311 135.468C58.9649 139.712 63.242 142.314 67.4841 141.28L114.169 129.907C118.411 128.873 121.012 124.595 119.978 120.351L96.2025 22.7613C95.1686 18.5176 90.8915 15.9152 86.6494 16.9487Z"
				fill={props.paper ?? PAPER}
				{...line}
			/>
			<path d="M35.2021 42.7552L97.2494 27.6387" {...line} />
			<path d="M68.3213 92.672L92.062 86.8881" {...line} />
			<path d="M72.5654 98.6239L89.7115 94.4466" {...line} />
			<rect
				x="53.5928"
				y="78.0964"
				width="8.82378"
				height="8.14503"
				rx="2.71501"
				transform="rotate(-13.6922 53.5928 78.0964)"
				fill={ACCENT}
			/>
			<rect
				x="64.8037"
				y="75.3651"
				width="8.82378"
				height="8.14503"
				rx="2.71501"
				transform="rotate(-13.6922 64.8037 75.3651)"
				fill={ACCENT}
			/>
			<rect
				x="76.0146"
				y="72.6338"
				width="8.82378"
				height="8.14503"
				rx="2.71501"
				transform="rotate(-13.6922 76.0146 72.6338)"
				fill={ACCENT}
			/>
			<rect
				x="87.2256"
				y="69.9026"
				width="8.82378"
				height="8.14503"
				rx="2.71501"
				transform="rotate(-13.6922 87.2256 69.9026)"
				fill={ACCENT}
			/>
			<path d="M55.7559 46.8308L79.4965 41.0469" {...line} />
			<path d="M56.7197 50.7876L68.5901 47.8956" {...line} />
			<circle
				cx="48.9844"
				cy="50.5765"
				r="3.39376"
				transform="rotate(-13.6922 48.9844 50.5765)"
				stroke={ink}
				strokeWidth="1.2"
			/>
			<rect x="97" y="81" width="35" height="35" rx="17.5" fill={ACCENT} />
			<path
				d="M107.77 98.8846L113.923 104.654L120.654 91.3846"
				stroke="black"
				strokeWidth="1.53846"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
